module.exports = __webpack_public_path__ + "static/app-3-8ed4f8cf24a06465699e31f03a24c757.png";